module.exports = __webpack_public_path__ + "img/buble.f3e7bfbc.svg";